import {register} from '../vendor/theme-scripts/theme-sections';
import {modal} from '../util/modal';

const selectors = {
  trigger: '[data-toggle-password-modal]',
  errors: '.storefront-password-form .errors',
};

const sections = {};

class PasswordPage {
  constructor(section) {
    this.container = section.container;

    this.trigger = this.container.querySelector(selectors.trigger);
    this.errors = this.container.querySelector(selectors.errors);

    this.init();
  }

  init() {
    modal('password');
    if (this.errors) {
      this.trigger.click();
    }
  }
}

const passwordSection = {
  onLoad() {
    sections[this.id] = new PasswordPage(this);
  },
};

register('password', passwordSection);
